export const INDUSTRIES = [
    { value: 'automotive', label: 'Automotive' },
    { value: 'aviation', label: 'Aviation' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'field_services', label: 'Field Services' },
    { value: 'general', label: 'General' }
];
export const IDENTIFIER_FORMATS = [
    { value: 'vin', label: 'VIN' },
    { value: 'license_plate', label: 'License Plate' },
    { value: 'odometer', label: 'Odometer' },
    { value: 'serial_number', label: 'Serial Number' },
    { value: 'aircraft_tail_number', label: 'Aircraft Tail Number' },
    { value: 'asset_tag', label: 'Asset Tag' },
    { value: 'shipping_tracking_number', label: 'Shipping Tracking Number' },
    { value: 'other', label: 'Other' }
];
export const getIndustryLabel = (value) =>
    INDUSTRIES.find(i => i.value === value)?.label ?? value;
export const getIdentifierLabel = (value) =>
    IDENTIFIER_FORMATS.find(f => f.value === value)?.label ?? value;